import React, {useMemo} from 'react'

export interface EditPermissionsInfo {
  canEdit: boolean
  canEditOnDefaultBranch: boolean
  fileExistsOnDefault: boolean
}

const EditPermissionsContext = React.createContext<EditPermissionsInfo>({
  canEdit: false,
  canEditOnDefaultBranch: false,
  fileExistsOnDefault: false,
})

interface EditPermissionsProviderProps {
  canEdit?: boolean
  canEditOnDefaultBranch?: boolean
  fileExistsOnDefault?: boolean
}

export function EditPermissionsProvider({
  children,
  canEdit = false,
  canEditOnDefaultBranch = false,
  fileExistsOnDefault = false,
}: React.PropsWithChildren<EditPermissionsProviderProps>) {
  const value = useMemo(
    () => ({
      canEdit,
      canEditOnDefaultBranch,
      fileExistsOnDefault,
    }),
    [canEdit, canEditOnDefaultBranch, fileExistsOnDefault],
  )

  return <EditPermissionsContext value={value}>{children}</EditPermissionsContext>
}

export function useEditPermissions() {
  return React.use(EditPermissionsContext)
}
